
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
    name: "PriVewDialog",
})
export default class extends Vue {
    dialogTableVisible = false;
    mediaList :any= [];
    preIndex = 0;
    public open(list, index) {
        this.mediaList = []
        this.mediaList = list
        this.preIndex = 0;
        this.dialogTableVisible = true;
    }
    upOrDownStep(num) {
        //0上一张，1下一张
        if (num == 0) {
            if (this.preIndex > 0) {
                this.preIndex--;
            }
        } else {
            if (this.preIndex != this.mediaList.length - 1) {
                this.preIndex++;
            }
        }
    }
    hideModal() {
        this.dialogTableVisible = false;
    }
}
